export const logoImg = 'https://cdn.poizon.com/node-common/b379587759ce349a6268ac90326022df.png'

export const top1Icon =
  'https://cdn.poizon.com/node-common/test/14df5fca-7cc2-538f-103f-417df8cade41.png'
export const top2Icon =
  'https://cdn.poizon.com/node-common/test/f9f63fd5-7a8a-54ed-127c-a4782f727968.png'
export const top3Icon =
  'https://cdn.poizon.com/node-common/test/413732f6-e150-4065-1eba-eeddd92c201d.png'
export const otherIcon =
  'https://cdn.poizon.com/node-common/test/356e0139-8e31-595d-0d95-bcb5f5895a8e.png'

export const upIcon = 'https://cdn.poizon.com/node-common/3ed4dd0f1587073df6a357d94d8fde74.png'

export const newsUpDisableIcon =
  'https://cdn.poizon.com/node-common/cb13524f42b9a316389cc912184517f0.png'

export const saleUpDisableIcon =
  'https://cdn.poizon.com/node-common/605059a97a4bfe92c9a19c316ea458c0.png'

export const newsUpIcon = 'https://cdn.poizon.com/node-common/873d395b092ae975258e79d18f77df5e.png'

export const saleUpIcon = 'https://cdn.poizon.com/node-common/1fcbc12c4529a3f9c61602f10acd56bc.png'

export const downAndUpArrow =
  'https://cdn.poizon.com/node-common/c6ccc9a015f1ef3a8ae6bc985d48e5db.png'

// export const upIcon = 'https://cdn.poizon.com/node-common/3ed4dd0f1587073df6a357d94d8fde74.png'

export const arrowDownWhite =
  'https://cdn.poizon.com/node-common/01b35cb6017940841291a37df953e83b.png'
